import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { cn } from 'utils/classNamesTailwind';
import { TbIllustration, TbIllustrationProps } from 'components/Figma';

interface EmptyStateProps {
  testId?: string;
  titleId?: string;
  title?: ReactNode;
  bold?: boolean;
  description?: ReactNode;
  action?: ReactNode;
  illustration?: TbIllustrationProps['name'];
  imageClassName?: string;
  gapClassName?: string;
}

export function EmptyState({
  testId = '',
  titleId = 'general.error.selectedFilter',
  title = undefined,
  bold = false,
  description = undefined,
  action = undefined,
  illustration = 'EmptyState',
  imageClassName = 'block max-w-fit',
  gapClassName = 'gap-4',
}: EmptyStateProps = {}) {
  const intl = useIntl();
  const resolvedTitle = title ?? intl.formatMessage({ id: titleId });

  return (
    <div className={cn('flex h-full justify-center items-center mx-auto py-16', gapClassName)} data-testid={testId}>
      <TbIllustration
        className={imageClassName}
        name={illustration}
        alt={
          typeof resolvedTitle === 'string' ? resolvedTitle : intl.formatMessage({ id: 'general.error.selectedFilter' })
        }
      />
      <div className="text-left">
        <Typography style={{ fontSize: 16, fontWeight: bold ? 700 : 300 }}>{resolvedTitle}</Typography>
        {description && <Typography style={{ fontSize: 14, fontWeight: 300 }}>{description}</Typography>}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}
